import {createRouter, createWebHistory} from 'vue-router'
import Home from '../views/Dashboard.vue'
import MainLayout from "../views/layouts/MainLayout";
import SignIn from "../views/auth/SignIn.vue";
import AnalyseDocument from "../views/finances/ImportExpenses.vue";

import store from "../store/index";
import Products from "../views/finances/Products.vue";
import ManageExpenses from "../views/finances/ManageExpenses.vue";

const routes = [
    {
        // authenticated routes
        path: "/sign-in",
        component: SignIn,
    },
    {
        // authenticated routes
        path: "/",
        component: MainLayout,
        children: [{
            path: "/",
            name: "Home",
            component: Home,
        }, {
            path: "/finances/import",
            name: "Analyse",
            component: AnalyseDocument,
        }, {
            path: "/finances/manage",
            name: "ManageExpenses",
            component: ManageExpenses,
        }, {
            path: "/finances/products",
            name: "Products",
            component: Products,
        }],
        meta: {requiresAuth: true}
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})


router.beforeEach((to, from) => {
    // redirect to login if not authenticated
    if (to.meta["requiresAuth"] && store.state.Auth.token === null) {
        return {
            path: '/sign-in',
            // save the location we were at to come back later
            query: {redirect: to.fullPath},
        };
    }

    // redirect to dashboard if logged in
    if(store.state.Auth.token !== null && to.path === "/sign-in"){
        let location = to.query["redirect"] || "/";
        return {
            path: location,
        };
    }
});
export default router
